import { Route } from 'react-router-dom'
import { t } from 'ttag'
import React from 'react'

import SupplyDemand from './SupplyDemand'
import ChoosingIndustry from './ChoosingIndustry'
import ChoosingIndustryList from './ChoosingIndustryList'
import IndustryProfile from './IndustryProfile'

import {
  loadInDemand,
  loadTopQcewEmployment,
  loadTopQcewWage
} from '../../actions/industry'
import { useInitDispatch, useTitleChange } from '../../util/hooks'

const InDemandIndustries = () => {
  useTitleChange(t`In Demand Industries`)
  useInitDispatch(loadInDemand())

  return <ChoosingIndustryList />
}
const TopEmployingIndustries = () => {
  useTitleChange(t`Top Employing Industries`)
  useInitDispatch(loadTopQcewEmployment())

  return <ChoosingIndustryList />
}
const TopPayingIndustries = () => {
  useTitleChange(t`Top Paying Industries`)
  useInitDispatch(loadTopQcewWage())

  return <ChoosingIndustryList />
}
const IndustryRoutes = () => {
  return (
    <>
      <Route path="/industry/supplydemand" component={SupplyDemand} />
      <Route path="/industry/choosing" exact component={ChoosingIndustry} />
      <Route path="/industry/choosing/wages" component={TopPayingIndustries} />
      <Route path="/industry/choosing/employment" component={TopEmployingIndustries} />
      <Route path="/industry/choosing/indemand" component={InDemandIndustries} />

      <Route path="/industry/detail/:naics" component={IndustryProfile} />
    </>
  )
}

export default IndustryRoutes
